import { fromJS, Map } from 'immutable';

export function request(state, action) {
    return state.set('state', 'IN_PROGRESS').set('items', fromJS({}));
}

export function error(state, {errors}) {
    return state.set('state', 'ERROR').set('errors', fromJS(errors));
}

export function finish(state, {ladders}) {
    return state.set('state', 'FINISHED').set('items', fromJS(ladders));
}
